<template>
  <div class="w-full">
    <div class="border-b border-gray-200 mb-8 overflow-x-scroll snap-x snap-center scrollbar-hide">
      <nav class="flex -mb-px">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          @click="activeTab = tab.value"
          :class="[
            'py-4 md:px-6 px-3 font-medium text-base border-b-2 whitespace-nowrap',
            activeTab === tab.value
              ? 'border-brand-button text-brand-black font-bold'
              : 'border-transparent text-gray-500hover:text-gray-700 hover:border-gray-300',
          ]"
        >
          {{ tab.label }}
        </button>
      </nav>
    </div>

    <div class="bg-white md:p-6 py-6 px-3 rounded-lg shadow-md">
      <CompanyInfoTab v-if="activeTab === 'company-info'" :companyDetails="companyDetails" @refreshCompanyProfile="getGalleryImages" />
      <AboutTab v-if="activeTab === 'about'" :companyDetails="companyDetails" @refreshCompanyProfile="getGalleryImages" />
      <BenefitsTab v-if="activeTab === 'benefits'" :companyDetails="companyDetails" @refreshCompanyProfile="getGalleryImages" />
      <TeamTab v-if="activeTab === 'team'" :companyDetails="companyDetails" @refreshCompanyProfile="getGalleryImages" />
      <CultureTab v-if="activeTab === 'culture'" :companyDetails="companyDetails" @refreshCompanyProfile="getGalleryImages" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import CompanyInfoTab from '@/components/settings/companyProfile/CompanyInfoTab.vue';
import AboutTab from '@/components/settings/companyProfile/AboutTab.vue';
import BenefitsTab from '@/components/settings/companyProfile/BenefitsTab.vue';
import TeamTab from '@/components/settings/companyProfile/TeamTab.vue';
import CultureTab from '@/components/settings/companyProfile/CultureTab.vue';
import { useStore } from 'vuex';

const store = useStore();

const companyDetails = ref(null);
const activeTab = ref('company-info');
const tabs = [
  { label: 'Company Info', value: 'company-info' },
  { label: 'About', value: 'about' },
  { label: 'Benefits', value: 'benefits' },
  { label: 'Team', value: 'team' },
  { label: 'Culture', value: 'culture' },
];
const fetchCompanyDetails = async () => {
  companyDetails.value = await store.getters['auth/userDetails'];
};

onMounted(async () => {
  fetchCompanyDetails();
   // store.dispatch('auth/getUser', { forceReload: true });
});
</script>
